import script from "./ImpressionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpressionComponent.vue?vue&type=script&setup=true&lang=js"

import "./ImpressionComponent.vue?vue&type=style&index=0&id=2831a368&lang=scss"

const __exports__ = script;

export default __exports__